import { render, staticRenderFns } from "./CustomerServices.vue?vue&type=template&id=20671a24&"
import script from "./CustomerServices.vue?vue&type=script&lang=js&"
export * from "./CustomerServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports